const types = {
  DEVICE_RESTART: "DEVICE_RESTART",
  DEVICE_OFFLINE: "DEVICE_OFFLINE",
  DISK_USAGE: "DISK_USAGE",
};

const descs = {
  DEVICE_OFFLINE: "Device has been offline",
  DEVICE_RESTART: "Player is started",
  DISK_USAGE: "Disk usage",
  UNKNOWN: "Unknown alert",
};

function getAlertDesc(type) {
  if (Object.prototype.hasOwnProperty.call(descs, type)) {
    return descs[type];
  }

  return descs.UNKNOWN;
}

const exports = {
  ALL: Object.keys(types),
  getAlertDesc: getAlertDesc,
};

for (let [k, v] of Object.entries(types)) {
  exports[k] = v;
}

module.exports = exports;
